<app-page-modifications>
  <app-header class="full-width"></app-header>
  <main id="content" class="js-content" role="main">
    <div class="grid-row">
      <div class="column-two-thirds">
        <p class="aa-title-size" tabindex="0">
          <strong>Session expired</strong>
        </p>
        <div class="notice">
          <strong class="visually-hidden">Warning</strong>
          <app-svg-warning></app-svg-warning>
          <strong class="aa-copy-size">
            A pupil’s session expired without submitting their check data
          </strong>
        </div>
        <br/>
        <div class="indented-text">
          <div class="summary aa-copy-size">Instructions for teachers: </div>
          <ol class="list list-number aa-copy-size">
            <li>Visit your school’s ‘Multiplication tables check’ area on NCA tools.</li>
            <li>Check your school’s pupil register for any pupils who have been marked as ‘Incomplete’ and set them up
                with a ‘Restart’ so they can take the check again.
            </li>
            <li>Click this link to refresh the page and <a routerLink="/sign-out">start the Multiplication tables check
              again.</a></li>
          </ol>
          <div class="aa-copy-size">If you need further assistance please contact the helpline for advice.</div>
          <br />
          <div class="panel panel-border-wide aa-copy-size aa-contrast-border">
            <div class="bold-small aa-copy-size">National curriculum assessments helpline</div>
            <div>Telephone: 0300 303 3013</div>
            <div>Monday to Friday, 9am to 5pm</div>
          </div>
        </div>
      </div>
    </div>
  </main>
</app-page-modifications>
